var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.roleRules.ATTENDANCE_FLG === "Y"
        ? [
            Object.keys(_vm.selectedStudent).length > 0
              ? [
                  _vm.attendances.length > 0 ||
                  _vm.schoolsPeriodAttendanceChecks()
                    ? _vm._l(_vm.attendanceList, function(school, idx) {
                        return _c(
                          "section",
                          { key: "school-" + idx },
                          [
                            _c("attendance-summary", {
                              attrs: { school: school.ATTENDANCES }
                            }),
                            _vm._v(" "),
                            _c("h2", [
                              _vm._v(
                                "\n\t\t\t\t\t\t" +
                                  _vm._s(school.SCHOOL_TITLE) +
                                  "\n\t\t\t\t\t"
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "attendance-tabs" },
                              [
                                _c(
                                  "tabs",
                                  {
                                    attrs: {
                                      options: { useUrlFragment: false }
                                    },
                                    on: { changed: _vm.changedTab }
                                  },
                                  [
                                    _c(
                                      "tab",
                                      {
                                        attrs: {
                                          name: "Daily Attendance",
                                          id: "AttendanceTab"
                                        }
                                      },
                                      [
                                        school.ATTENDANCES.length > 0
                                          ? [
                                              _c(
                                                "table-editable-list",
                                                {
                                                  attrs: {
                                                    columns: _vm.columns,
                                                    "show-select": false,
                                                    "show-actions": false
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "template",
                                                    { slot: "data-row" },
                                                    [
                                                      _vm._l(
                                                        school.ATTENDANCES,
                                                        function(
                                                          attendance,
                                                          index
                                                        ) {
                                                          return [
                                                            _c(
                                                              "table-list-row",
                                                              {
                                                                key:
                                                                  "attendance-" +
                                                                  index,
                                                                attrs: {
                                                                  columns:
                                                                    _vm.columns,
                                                                  rowdata: attendance,
                                                                  rowIndex: index,
                                                                  showActions: false
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "template",
                                                                  {
                                                                    slot:
                                                                      "attendance"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                        _vm._s(
                                                                          attendance.DESCRIPTION
                                                                        ) +
                                                                        "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                                                    ),
                                                                    !attendance.PENDING_FORM_EXISTS &&
                                                                    _vm
                                                                      .onDemandForms
                                                                      .length >
                                                                      0 &&
                                                                    attendance.EXCUSED_STATUS !==
                                                                      "E"
                                                                      ? _c(
                                                                          "button",
                                                                          {
                                                                            staticClass:
                                                                              "btn btn-primary btn-sm pull-right",
                                                                            attrs: {
                                                                              type:
                                                                                "button"
                                                                            },
                                                                            on: {
                                                                              click: function(
                                                                                $event
                                                                              ) {
                                                                                return _vm.SubmitAbsenceFormButtonClick(
                                                                                  attendance.FORMATTED_DATE
                                                                                )
                                                                              }
                                                                            }
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                                _vm._s(
                                                                                  _vm.$t(
                                                                                    "MAIN_CONTENT.Attendance.submitAbsenceForm"
                                                                                  )
                                                                                ) +
                                                                                "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                                                            )
                                                                          ]
                                                                        )
                                                                      : attendance.PENDING_FORM_EXISTS &&
                                                                        attendance.EXCUSED_STATUS !==
                                                                          "E"
                                                                      ? _c(
                                                                          "span",
                                                                          {
                                                                            staticClass:
                                                                              "badge badge-info pull-right"
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                                _vm._s(
                                                                                  _vm.$t(
                                                                                    "MAIN_CONTENT.Attendance.pendingForm"
                                                                                  )
                                                                                ) +
                                                                                "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                                                            )
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                    _vm._v(" "),
                                                                    attendance
                                                                      .ATTENDANCE_DETAILS
                                                                      .length
                                                                      ? _c(
                                                                          "ul",
                                                                          _vm._l(
                                                                            attendance.ATTENDANCE_DETAILS,
                                                                            function(
                                                                              detail
                                                                            ) {
                                                                              return _c(
                                                                                "li",
                                                                                {
                                                                                  key:
                                                                                    detail.row_id
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                                      _vm._s(
                                                                                        detail.ATTENDANCE_CODE_DESC
                                                                                      ) +
                                                                                      " (" +
                                                                                      _vm._s(
                                                                                        detail.ATTENDANCE_CODE
                                                                                      ) +
                                                                                      ") -\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                                                                  ),
                                                                                  _c(
                                                                                    "i",
                                                                                    [
                                                                                      !!detail.OUT_TIME &&
                                                                                      !!detail.IN_TIME
                                                                                        ? [
                                                                                            _vm._v(
                                                                                              "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tTime Out: " +
                                                                                                _vm._s(
                                                                                                  _vm._f(
                                                                                                    "time"
                                                                                                  )(
                                                                                                    detail.OUT_TIME,
                                                                                                    "mmmm, dd yyyy hh:mm:ss"
                                                                                                  )
                                                                                                ) +
                                                                                                " - Time In: " +
                                                                                                _vm._s(
                                                                                                  _vm._f(
                                                                                                    "time"
                                                                                                  )(
                                                                                                    detail.IN_TIME,
                                                                                                    "mmmm, dd yyyy hh:mm:ss"
                                                                                                  )
                                                                                                ) +
                                                                                                "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                                                                            )
                                                                                          ]
                                                                                        : _vm._e(),
                                                                                      _vm._v(
                                                                                        " "
                                                                                      ),
                                                                                      !detail.OUT_TIME &&
                                                                                      !!detail.IN_TIME
                                                                                        ? [
                                                                                            _vm._v(
                                                                                              "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t Time In: ( " +
                                                                                                _vm._s(
                                                                                                  _vm._f(
                                                                                                    "time"
                                                                                                  )(
                                                                                                    detail.IN_TIME,
                                                                                                    "mmmm, dd yyyy hh:mm:ss"
                                                                                                  )
                                                                                                ) +
                                                                                                " )\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                                                                            )
                                                                                          ]
                                                                                        : _vm._e(),
                                                                                      _vm._v(
                                                                                        " "
                                                                                      ),
                                                                                      !!detail.OUT_TIME &&
                                                                                      !detail.IN_TIME
                                                                                        ? [
                                                                                            _vm._v(
                                                                                              "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t Time Out: ( " +
                                                                                                _vm._s(
                                                                                                  _vm._f(
                                                                                                    "time"
                                                                                                  )(
                                                                                                    detail.OUT_TIME,
                                                                                                    "mmmm, dd yyyy hh:mm:ss"
                                                                                                  )
                                                                                                ) +
                                                                                                " )\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                                                                            )
                                                                                          ]
                                                                                        : _vm._e(),
                                                                                      _vm._v(
                                                                                        " "
                                                                                      ),
                                                                                      !!detail.MINUTES
                                                                                        ? [
                                                                                            _vm._v(
                                                                                              "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t- (" +
                                                                                                _vm._s(
                                                                                                  detail.MINUTES
                                                                                                ) +
                                                                                                " minutes)\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                                                                            )
                                                                                          ]
                                                                                        : _vm._e()
                                                                                    ],
                                                                                    2
                                                                                  )
                                                                                ]
                                                                              )
                                                                            }
                                                                          ),
                                                                          0
                                                                        )
                                                                      : _vm._e()
                                                                  ]
                                                                )
                                                              ],
                                                              2
                                                            )
                                                          ]
                                                        }
                                                      )
                                                    ],
                                                    2
                                                  )
                                                ],
                                                2
                                              )
                                            ]
                                          : [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-xs-12 alert alert-info"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n\t\t\t\t\t\t\t\t\t\t" +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "MAIN_CONTENT.Attendance.noAbsenceRecords"
                                                        )
                                                      ) +
                                                      "\n\t\t\t\t\t\t\t\t\t"
                                                  )
                                                ]
                                              )
                                            ]
                                      ],
                                      2
                                    ),
                                    _vm._v(" "),
                                    _vm.loadedPeriod
                                      ? [
                                          !!_vm.periodAttendances[
                                            school.SCHOOL_ID
                                          ] &&
                                          _vm.periodAttendances[
                                            school.SCHOOL_ID
                                          ].attendance_type === "P"
                                            ? _c(
                                                "tab",
                                                {
                                                  attrs: {
                                                    name:
                                                      school.SCHOOL_TITLE +
                                                      " Period Attendance",
                                                    id: "PeriodAttendanceTab"
                                                  }
                                                },
                                                [
                                                  _vm.loadedPeriod
                                                    ? [
                                                        _c("h2", [
                                                          _vm._v(
                                                            "\n\t\t\t\t\t\t\t\t\t\t\t" +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "MAIN_CONTENT.Attendance.periodAttendance"
                                                                )
                                                              ) +
                                                              "\n\t\t\t\t\t\t\t\t\t\t"
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "row margin-bottom-5"
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "col-xs-6 col-md-3 pointer"
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    on: {
                                                                      click: function(
                                                                        $event
                                                                      ) {
                                                                        _vm.showMonthSelectModal = true
                                                                      }
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "font-awesome-icon",
                                                                      {
                                                                        directives: [
                                                                          {
                                                                            name:
                                                                              "tooltip",
                                                                            rawName:
                                                                              "v-tooltip.top-center",
                                                                            value: {
                                                                              content: _vm.$t(
                                                                                "MAIN_CONTENT.Attendance.selectMonthsToDisplay"
                                                                              ),
                                                                              trigger:
                                                                                "hover"
                                                                            },
                                                                            expression:
                                                                              "{\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tcontent: $t( 'MAIN_CONTENT.Attendance.selectMonthsToDisplay' ),\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\ttrigger: 'hover'\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t}",
                                                                            modifiers: {
                                                                              "top-center": true
                                                                            }
                                                                          }
                                                                        ],
                                                                        staticClass:
                                                                          "cursor-pointer",
                                                                        attrs: {
                                                                          icon:
                                                                            "list",
                                                                          size:
                                                                            "lg"
                                                                        }
                                                                      }
                                                                    ),
                                                                    _vm._v(
                                                                      "\n\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                        _vm._s(
                                                                          _vm.$t(
                                                                            "MAIN_CONTENT.Attendance.selectMonthsToDisplay"
                                                                          )
                                                                        ) +
                                                                        "\n\t\t\t\t\t\t\t\t\t\t\t\t"
                                                                    )
                                                                  ],
                                                                  1
                                                                ),
                                                                _vm._v(" "),
                                                                _c("modal", {
                                                                  attrs: {
                                                                    "modal-title": _vm.$t(
                                                                      "MAIN_CONTENT.Attendance.selectMonthsToDisplay"
                                                                    ),
                                                                    show:
                                                                      _vm.showMonthSelectModal,
                                                                    "dialog-size":
                                                                      "lg",
                                                                    name:
                                                                      "periodAttendanceCodes"
                                                                  },
                                                                  on: {
                                                                    close: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.closeModal()
                                                                    }
                                                                  },
                                                                  scopedSlots: _vm._u(
                                                                    [
                                                                      {
                                                                        key:
                                                                          "default",
                                                                        fn: function(
                                                                          modalProps
                                                                        ) {
                                                                          return [
                                                                            _c(
                                                                              "div",
                                                                              {
                                                                                staticClass:
                                                                                  "form-group",
                                                                                staticStyle: {
                                                                                  "min-height":
                                                                                    "135px"
                                                                                }
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "div",
                                                                                  {
                                                                                    staticClass:
                                                                                      "col-xs-12"
                                                                                  },
                                                                                  [
                                                                                    _c(
                                                                                      "sapphire-toggle",
                                                                                      {
                                                                                        staticClass:
                                                                                          "col-xs-6 col-md-4 col-lg-3",
                                                                                        attrs: {
                                                                                          disabled:
                                                                                            _vm.showFullYear,
                                                                                          showInFront: false,
                                                                                          label:
                                                                                            "Show Full Year",
                                                                                          "aria-label":
                                                                                            "Show Full Year"
                                                                                        },
                                                                                        model: {
                                                                                          value:
                                                                                            _vm.showFullYear,
                                                                                          callback: function(
                                                                                            $$v
                                                                                          ) {
                                                                                            _vm.showFullYear = $$v
                                                                                          },
                                                                                          expression:
                                                                                            "showFullYear"
                                                                                        }
                                                                                      }
                                                                                    )
                                                                                  ],
                                                                                  1
                                                                                ),
                                                                                _vm._v(
                                                                                  " "
                                                                                ),
                                                                                _c(
                                                                                  "div",
                                                                                  {
                                                                                    staticClass:
                                                                                      "col-xs-12"
                                                                                  },
                                                                                  [
                                                                                    _c(
                                                                                      "ul",
                                                                                      {
                                                                                        staticClass:
                                                                                          "selected-months-list"
                                                                                      },
                                                                                      [
                                                                                        _vm._l(
                                                                                          _vm.monthsInSchoolYear,
                                                                                          function(
                                                                                            month,
                                                                                            monthsInYearIndex
                                                                                          ) {
                                                                                            return _c(
                                                                                              "li",
                                                                                              {
                                                                                                key:
                                                                                                  "months_list_" +
                                                                                                  monthsInYearIndex,
                                                                                                attrs: {
                                                                                                  "data-columns":
                                                                                                    "3"
                                                                                                }
                                                                                              },
                                                                                              [
                                                                                                _c(
                                                                                                  "sapphire-toggle",
                                                                                                  {
                                                                                                    staticClass:
                                                                                                      "col-xs-6 col-md-4 col-lg-3",
                                                                                                    attrs: {
                                                                                                      label:
                                                                                                        month.name,
                                                                                                      showInFront: false,
                                                                                                      "aria-label":
                                                                                                        month.name
                                                                                                    },
                                                                                                    on: {
                                                                                                      input: function(
                                                                                                        $event
                                                                                                      ) {
                                                                                                        if (
                                                                                                          month.checked
                                                                                                        ) {
                                                                                                          _vm.showFullYear = false
                                                                                                        }
                                                                                                      }
                                                                                                    },
                                                                                                    model: {
                                                                                                      value:
                                                                                                        month.checked,
                                                                                                      callback: function(
                                                                                                        $$v
                                                                                                      ) {
                                                                                                        _vm.$set(
                                                                                                          month,
                                                                                                          "checked",
                                                                                                          $$v
                                                                                                        )
                                                                                                      },
                                                                                                      expression:
                                                                                                        "month.checked"
                                                                                                    }
                                                                                                  }
                                                                                                )
                                                                                              ],
                                                                                              1
                                                                                            )
                                                                                          }
                                                                                        ),
                                                                                        _vm._v(
                                                                                          " "
                                                                                        ),
                                                                                        _c(
                                                                                          "li"
                                                                                        )
                                                                                      ],
                                                                                      2
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              ]
                                                                            )
                                                                          ]
                                                                        }
                                                                      }
                                                                    ],
                                                                    null,
                                                                    true
                                                                  )
                                                                })
                                                              ],
                                                              1
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "col-xs-6 col-md-3 pointer",
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    _vm.showPeriodAttendanceCodeModal = true
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "font-awesome-icon",
                                                                  {
                                                                    directives: [
                                                                      {
                                                                        name:
                                                                          "tooltip",
                                                                        rawName:
                                                                          "v-tooltip.top-center",
                                                                        value: {
                                                                          content: _vm.$t(
                                                                            "MAIN_CONTENT.Attendance.periodAttendanceCodesLegend"
                                                                          ),
                                                                          trigger:
                                                                            "hover"
                                                                        },
                                                                        expression:
                                                                          "{\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tcontent: $t( 'MAIN_CONTENT.Attendance.periodAttendanceCodesLegend' ),\n\t\t\t\t\t\t\t\t\t\t\t\t\t\ttrigger: 'hover'\n\t\t\t\t\t\t\t\t\t\t\t\t\t}",
                                                                        modifiers: {
                                                                          "top-center": true
                                                                        }
                                                                      }
                                                                    ],
                                                                    attrs: {
                                                                      icon:
                                                                        "list",
                                                                      size: "lg"
                                                                    }
                                                                  }
                                                                ),
                                                                _vm._v(
                                                                  "\n\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "MAIN_CONTENT.Attendance.periodAttendanceCodesIcon"
                                                                      )
                                                                    ) +
                                                                    "\n\t\t\t\t\t\t\t\t\t\t\t"
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c("br"),
                                                        _vm._v(" "),
                                                        _c(
                                                          "modal",
                                                          {
                                                            attrs: {
                                                              "modal-title": _vm.$t(
                                                                "MAIN_CONTENT.Attendance.periodAttendanceCodes"
                                                              ),
                                                              show:
                                                                _vm.showPeriodAttendanceCodeModal,
                                                              "dialog-size":
                                                                "md",
                                                              name:
                                                                "periodAttendanceCodes"
                                                            },
                                                            on: {
                                                              close: function(
                                                                $event
                                                              ) {
                                                                return _vm.closeModal()
                                                              }
                                                            },
                                                            scopedSlots: _vm._u(
                                                              [
                                                                {
                                                                  key:
                                                                    "default",
                                                                  fn: function(
                                                                    modalProps
                                                                  ) {
                                                                    return [
                                                                      _c(
                                                                        "table-editable-list",
                                                                        {
                                                                          attrs: {
                                                                            columns: [
                                                                              {
                                                                                heading:
                                                                                  "Attendance Code",
                                                                                key:
                                                                                  "ATTENDANCE_CODE",
                                                                                customCol:
                                                                                  "code"
                                                                              },
                                                                              {
                                                                                heading:
                                                                                  "Description",
                                                                                key:
                                                                                  "ATTENDANCE_CODE_DESC",
                                                                                customCol:
                                                                                  "desc"
                                                                              }
                                                                            ],
                                                                            "show-select": false,
                                                                            "show-actions": false
                                                                          }
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "template",
                                                                            {
                                                                              slot:
                                                                                "data-row"
                                                                            },
                                                                            _vm._l(
                                                                              _vm.usedPeriodAttendanceCodesList(
                                                                                school.SCHOOL_ID
                                                                              ),
                                                                              function(
                                                                                code,
                                                                                codeIndex
                                                                              ) {
                                                                                return _c(
                                                                                  "tr",
                                                                                  {
                                                                                    key:
                                                                                      "periodCodes_" +
                                                                                      code.ATTENDANCE_CODE +
                                                                                      "_" +
                                                                                      codeIndex
                                                                                  },
                                                                                  [
                                                                                    _c(
                                                                                      "td",
                                                                                      [
                                                                                        _vm._v(
                                                                                          _vm._s(
                                                                                            code.ATTENDANCE_CODE
                                                                                          )
                                                                                        )
                                                                                      ]
                                                                                    ),
                                                                                    _vm._v(
                                                                                      " "
                                                                                    ),
                                                                                    _c(
                                                                                      "td",
                                                                                      [
                                                                                        _vm._v(
                                                                                          _vm._s(
                                                                                            code.ATTENDANCE_CODE_DESC
                                                                                          )
                                                                                        )
                                                                                      ]
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              }
                                                                            ),
                                                                            0
                                                                          )
                                                                        ],
                                                                        2
                                                                      )
                                                                    ]
                                                                  }
                                                                }
                                                              ],
                                                              null,
                                                              true
                                                            )
                                                          },
                                                          [
                                                            _vm._v(" "),
                                                            _c(
                                                              "template",
                                                              {
                                                                slot: "footer"
                                                              },
                                                              [
                                                                _c(
                                                                  "button",
                                                                  {
                                                                    staticClass:
                                                                      "btn btn-transparent pull-right",
                                                                    attrs: {
                                                                      type:
                                                                        "button"
                                                                    },
                                                                    on: {
                                                                      click: function(
                                                                        $event
                                                                      ) {
                                                                        return _vm.closeModal()
                                                                      }
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                        _vm._s(
                                                                          _vm.$t(
                                                                            "MAIN_CONTENT.commonContent.closeButton"
                                                                          )
                                                                        ) +
                                                                        "\n\t\t\t\t\t\t\t\t\t\t\t\t"
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            )
                                                          ],
                                                          2
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "table-editable-list",
                                                          {
                                                            attrs: {
                                                              columns: _vm.getPeriodAttendanceColumns(
                                                                school.SCHOOL_ID
                                                              ),
                                                              "show-select": false,
                                                              "show-actions": false
                                                            }
                                                          },
                                                          [
                                                            _c(
                                                              "template",
                                                              {
                                                                slot: "data-row"
                                                              },
                                                              [
                                                                _vm._l(
                                                                  _vm
                                                                    .periodAttendances[
                                                                    school
                                                                      .SCHOOL_ID
                                                                  ].days,
                                                                  function(
                                                                    day,
                                                                    dayIndex
                                                                  ) {
                                                                    return [
                                                                      _vm.isSelectedDate(
                                                                        _vm.formatDate(
                                                                          day,
                                                                          "MMMM"
                                                                        )
                                                                      ) ||
                                                                      _vm.showFullYear
                                                                        ? _c(
                                                                            "tr",
                                                                            {
                                                                              key:
                                                                                "days_" +
                                                                                dayIndex +
                                                                                "_school_" +
                                                                                school.SCHOOL_ID
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "td",
                                                                                [
                                                                                  _vm._v(
                                                                                    "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                                      _vm._s(
                                                                                        day
                                                                                      ) +
                                                                                      "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                                                                  )
                                                                                ]
                                                                              ),
                                                                              _vm._v(
                                                                                " "
                                                                              ),
                                                                              _vm._l(
                                                                                _vm.getPeriodAttendanceColumns(
                                                                                  school.SCHOOL_ID
                                                                                ),
                                                                                function(
                                                                                  period,
                                                                                  periodName
                                                                                ) {
                                                                                  return [
                                                                                    period.heading !==
                                                                                    "Date"
                                                                                      ? _c(
                                                                                          "td",
                                                                                          {
                                                                                            directives: [
                                                                                              {
                                                                                                name:
                                                                                                  "tooltip",
                                                                                                rawName:
                                                                                                  "v-tooltip.top-center",
                                                                                                value: {
                                                                                                  content: _vm.getPeriodCodeDetail(
                                                                                                    period.heading,
                                                                                                    day,
                                                                                                    school.SCHOOL_ID,
                                                                                                    _vm.getAttendanceCode(
                                                                                                      school.SCHOOL_ID,
                                                                                                      day,
                                                                                                      period.heading
                                                                                                    )
                                                                                                  ),
                                                                                                  trigger:
                                                                                                    "hover click"
                                                                                                },
                                                                                                expression:
                                                                                                  "{\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tcontent: getPeriodCodeDetail(\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tperiod.heading,\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tday,\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tschool.SCHOOL_ID,\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tgetAttendanceCode( school.SCHOOL_ID, day, period.heading )\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t),\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\ttrigger: 'hover click'\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t}",
                                                                                                modifiers: {
                                                                                                  "top-center": true
                                                                                                }
                                                                                              }
                                                                                            ],
                                                                                            key:
                                                                                              "periods_period_" +
                                                                                              periodName +
                                                                                              "_days_" +
                                                                                              dayIndex
                                                                                          },
                                                                                          [
                                                                                            _vm._v(
                                                                                              "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                                                _vm._s(
                                                                                                  _vm.getAttendanceCode(
                                                                                                    school.SCHOOL_ID,
                                                                                                    day,
                                                                                                    period.heading
                                                                                                  )
                                                                                                ) +
                                                                                                "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                                                                            )
                                                                                          ]
                                                                                        )
                                                                                      : _vm._e()
                                                                                  ]
                                                                                }
                                                                              )
                                                                            ],
                                                                            2
                                                                          )
                                                                        : _vm._e()
                                                                    ]
                                                                  }
                                                                )
                                                              ],
                                                              2
                                                            )
                                                          ],
                                                          2
                                                        )
                                                      ]
                                                    : _vm._e()
                                                ],
                                                2
                                              )
                                            : _vm._e()
                                        ]
                                      : _vm._e()
                                  ],
                                  2
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      })
                    : [
                        _c(
                          "div",
                          { staticClass: "col-xs-12 alert alert-info" },
                          [
                            _vm._v(
                              "\n\t\t\t\t\t" +
                                _vm._s(
                                  _vm.$t(
                                    "MAIN_CONTENT.Attendance.noAbsenceRecords"
                                  )
                                ) +
                                "\n\t\t\t\t"
                            )
                          ]
                        )
                      ]
                ]
              : [
                  _vm._v(
                    "\n\t\t\t" +
                      _vm._s(
                        _vm.$t(
                          "MAIN_CONTENT.commonContent.noStudentHasBeenSelectedWithPeriod"
                        )
                      ) +
                      "\n\t\t"
                  )
                ]
          ]
        : [
            _vm._v(
              "\n\t\t" +
                _vm._s(
                  _vm.$t(
                    "MAIN_CONTENT.Attendance.youDoNotHaveAccessToThisStudentWithPeriod"
                  )
                ) +
                "\n\t"
            )
          ],
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            "modal-title": _vm.$t(
              "MAIN_CONTENT.StudentDataForms.onDemandFormsTitleCase"
            ),
            show: _vm.showModal,
            "dialog-size": "md",
            name: "attendanceFormModal"
          },
          on: {
            close: function($event) {
              return _vm.closeModal()
            }
          },
          scopedSlots: _vm._u([
            {
              key: "default",
              fn: function(modalProps) {
                return [
                  _c(
                    "table-editable-list",
                    {
                      attrs: {
                        columns: _vm.onDemandColumns,
                        headerClasses: "th-left",
                        "show-select": false,
                        "show-actions": false
                      }
                    },
                    [
                      _c(
                        "template",
                        { slot: "data-row" },
                        [
                          _vm._l(_vm.onDemandForms, function(
                            form,
                            studentDataFormsIdx
                          ) {
                            return [
                              _c("table-list-row", {
                                key: "studentDataForms-" + studentDataFormsIdx,
                                attrs: {
                                  columns: _vm.onDemandColumns,
                                  rowdata: form,
                                  useAnchor: false,
                                  showActions: false,
                                  rowIndex: studentDataFormsIdx
                                }
                              })
                            ]
                          })
                        ],
                        2
                      )
                    ],
                    2
                  )
                ]
              }
            }
          ])
        },
        [
          _vm._v(" "),
          _c("template", { slot: "footer" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-transparent pull-right",
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    return _vm.closeModal()
                  }
                }
              },
              [
                _vm._v(
                  "\n\t\t\t\t" +
                    _vm._s(_vm.$t("MAIN_CONTENT.commonContent.closeButton")) +
                    "\n\t\t\t"
                )
              ]
            )
          ])
        ],
        2
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }